var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {
            $('#sbi_images').addClass('swiper-container');
            $('#sbi_images').wrapInner('<div class="swiper-wrapper">');
            $('#sbi_images .sbi_item').wrap('<div class="swiper-slide">');

            const swiperInstagram = new Swiper('#sbi_images', {
                slidesPerView: "auto",
                //centeredSlides: true,
                speed: 400,
                spaceBetween: 24,
                initialSlide: 0,
                navigation: {
                    nextEl: '.block-instagram-slider .swiper-button-next',
                    prevEl: '.block-instagram-slider .swiper-button-prev',
                },
                on: {
                    init: function(){
                        //setPosition();

                        if ($('html').is(':lang(de-DE)')) {
                            console.log('DE');
                            $('.sb_link_button_wrapper .fz-button-rounded span', $('body')).html('Post ansehen');
                        }
                    },
                    slideChange: function () {

                    },
                },
            });

            function setPosition(){
                const containerWidth    = $('.block-instagram-slider .swiper-container').width();
                const slideWidth        = $('.block-instagram-slider .swiper-wrapper .swiper-slide').width();
                const margin            = (containerWidth - slideWidth)/2;

                $('.block-instagram-slider .swiper-wrapper').css('margin-left','-' + margin + 'px');
            }
            $(window).on('resize',function(){
                //setPosition();
            });

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=instagram-slider', initializeBlock);
    }
});
